(function ($, Drupal) {
  Drupal.behaviors.breadcrumbShrink = {
    attach: function (context, settings) {
      let pre_mut;

      function compactHTMLList(listElement) {
        if (listElement !== null) {
          pre_mut = Array.from(listElement.children).map(li => li.cloneNode(true));

          let debugging = false;
          if (debugging) {
            console.log(pre_mut);
            console.log("breadcrumb function is working");
          }

          const items = Array.from(listElement.children);

          if (items.length <= 3) {
            if (debugging) console.log("Breadcrumb is less then 3");
            return; // Do nothing if 4 or fewer
          }
          // Keep first item and last 3 items
          const first = items[0];
          const lastThree = items.slice(-2);

          // Clear the list
          listElement.innerHTML = '';

          // Append: first, dot, then last threes
          listElement.appendChild(first);

          const dotItem = document.createElement('li');
          dotItem.classList.add("breadcrumb-item");
          const dotLink = document.createElement('a');
          const svg = document.createElement('div');
          svg.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<g clip-path="url(#clip0_94_1587)">\n' +
            '<path fill-rule="evenodd" clip-rule="evenodd" d="M16.6847 12L9.40654 3.99397L7.92666 5.33931L13.9818 12L7.92666 18.6606L9.40654 20.006L16.6847 12Z" fill="#000000"/>\n' +
            '</g>\n' +
            '<defs>\n' +
            '<clipPath id="clip0_94_1587">\n' +
            '<rect width="16" height="16" fill="white" transform="translate(4 20) rotate(-90)"/>\n' +
            '</clipPath>\n' +
            '</defs>\n' +
            '</svg>';
          dotLink.textContent = '...';
          dotLink.href = '#'; // Set your desired link or leave as "#" for now
          dotLink.addEventListener('click', (e) => {
            e.preventDefault();
            restore_original_list(listElement)
          });
          dotItem.appendChild(svg.children[0]);
          dotItem.appendChild(dotLink);
          listElement.appendChild(dotItem);

          lastThree.forEach(item => {
            listElement.appendChild(item);
          });
        }

      }

      function restore_original_list(listElement) {
        if (!pre_mut) return; // Nothing to restore

        listElement.innerHTML = ''; // Clear list
        pre_mut.forEach(item => {
          listElement.appendChild(item.cloneNode(true));
        });
      }


      // Usage
      const myList = document.getElementById('breadcrumb-list');
      compactHTMLList(myList);
    }
  };
})(jQuery, Drupal);